<template src="./OrderGHTKComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {AppConstant, CommonText} from "@/supports/app.constant";
import {ref, onMounted, computed, reactive, watch} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import {useRouter} from "vue-router";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import SelectCustom from "@/components/inputs/select/custom/SelectCustom.vue";
import ModalDeliveryProductListComponent
  from "@/components/modals/modal-delivery-product-list/ModalDeliveryProductListComponent.vue";
import ModalProductExportComponent from "@/components/modals/modal-export/ModalExportComponent.vue";
import LoadingComponent from "@/components/loading/LoadingComponent.vue";
import ModalProductImportComponent from "@/components/modals/modal-product-import/ModalProductImportComponent.vue";
import ModalExportComponent from "@/components/modals/modal-export/ModalExportComponent.vue";
import {useStore} from "@/stores/store.js";
import {useGHTKStore} from "@/stores/syncGHTK.js";
import ModalCalendarComponent from "@/components/modals/modal-calendar/ModalCalendarComponent.vue";
import ErrorMessageService from "@/services/error-message.service.js";

export default {
  name: 'OrderGHTKComponent',
  components: {
    ModalCalendarComponent,
    ModalExportComponent,
    ModalProductImportComponent,
    LoadingComponent,
    ModalProductExportComponent,
    ModalDeliveryProductListComponent,
    SelectCustom,
    InputCheckboxOne,
    PaginateComponent,
    ButtonAddComponent,
    IconTrash,
    IconEdit,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome},
  setup() {
    const dataHeaderTable =  ref({
      store: {
        label: 'Cửa hàng',
        order: 1,
        width: '10%',
      },
      partner: {
        label: 'Đối tác',
        order: 3,
        width: '20%',
      },
      status: {
        label: 'Trạng thái giao hàng',
        order: 4,
        width: '10%',
      },
      tracking_id: {
        label: 'Mã vận đơn GHTK',
        order: 5,
        width: '10%',
      },
      shipping_fee: {
        label: 'Phí ship',
        order: 6,
        width: '10%',
      },
      pick_date: {
        label: 'Ngày lấy đơn',
        order: 7,
        width: '10%',
      },
      deliver_date: {
        label: 'Ngày giao đơn',
        order: 8,
        width: '10%',
      },
    })
    const labelButtonSearch = ref('Tìm kiếm')
    const labelButtonCreate = ref('Tạo đơn hàng')
    const urlOrigin = ref('/product/list/')
    const dataSearch = ref({
      store_id: {
        id: 'store_id',
        label: 'Cửa hàng',
        placeholder: 'Tên cửa hàng',
        value: '',
        required: false,
        options: []
      },
      status: {
        id: 'status',
        label: 'Trạng thái',
        placeholder: 'Trạng thái',
        value: 1,
        required: false
      },
      pick_date: {
        id: 'pick_date',
        label: 'Ngày lấy đơn',
        placeholder: 'Ngày lấy đơn',
        value: '',
        required: false,
      },
      deliver_date: {
        id: 'deliver_date',
        label: 'Ngày giao đơn',
        placeholder: 'Ngày giao đơn',
        value: '',
        required: false,
      },
    })
    const checkAll = ref(false)
    const errorMessage = ref([])
    const checkItems = ref({})
    const listItemSelected = ref([])
    const eventClickShowModalExport = ref(false)
    const eventClickShowModalImport = ref(false)
    const listProductsSelected = ref([])
    const isLoading = ref(false)
    const messError = ref('')
    const location = ref('Sản phẩm')
    const table = ref('product')
    const showCalendar = ref(false)
    const stateModal = reactive({
      modalCalendar: null,
    })
    const statusOrder = reactive([
      {
        key: 1,
        label: 'Chờ nhận giao hàng'
      },
      {
        key: 2,
        label: 'Nhận giao hàng'
      },
      {
        key: 3,
        label: 'Đã giao hàng'
      },
      {
        key: 4,
        label: 'Đang giao hàng'
      },
      {
        key: 5,
        label: 'Trả hàng'
      },
      {
        key: 6,
        label: 'Huỷ giao hàng'
      },
    ])
    const ghtkExpirationDateSelected = ref(null)

    const selectAction = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_ORDER_GHTK))
    const selectLimitPage = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_PAGE))

    const syncGHTKStore = useGHTKStore()
    const accountStore = useAccountStore()
    const storeCompStore = useStore()
    const router = useRouter()

    onMounted(() => {
      stateModal.modalCalendar = new bootstrap.Modal('#modalCalendar', {})
      if(!storeCompStore.stores.length) {
        getListStores();
      }else {
        storeCompStore.stores.forEach((store) => {
          dataSearch.value.store_id.options.push({
            name: store.name,
            value: store.id
          })
        })
      }
      getListOrder()
    });
    const listGHTK = computed(() => {
      return syncGHTKStore.listSyncGHTK;
    });
    const paginate = computed(() => {
      return syncGHTKStore.paginate;
    });

    function onChange(value, name) {
      dataSearch.value[name].value = value;
      if (name === 'expired_at' && value === AppConstant.GHTK_EXPIRATION_DATE_TOKEN_OPTION_8) {
        showCalendar.value = true
        stateModal.modalCalendar.show()
      }
    }

    async function getListStores() {
      const params = {
        id: accountStore.account.company.id,
        type: 1
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/stores/list-stores';
      await storeCompStore.getListStores(url, params);
    }

    function searchGHTK() {
      getListOrder(1);
    }

    const listOrders = computed(() => {
      return syncGHTKStore.lisOrderGHTK;
    });

    watch(() => syncGHTKStore.lisOrderGHTK, (newListOrderGHTK) => {
      newListOrderGHTK.forEach((product) => {
        if(checkItems.value[product.id] === undefined) {
          checkItems.value[product.id] = false
        }
      })
    });


    function getListOrder(page, take = 10) {
      const params = {
        id: accountStore.account.company.id,
        store_id: dataSearch.value.store_id.value,
        status: dataSearch.value.status.value,
        third_party_id: 1,
        page: page,
        take: take,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/third-party/order/list-order';
      syncGHTKStore.getListOrder(url, params);
    }

    function showSyncGHTKDetail(syncId) {
      router.push('/third-party/ghtk/detail/' + syncId)
    }

    function onChangeSelectItem(value, name) {
      checkItems.value[name] = value
      let counterChecked = 0
      listOrders.value.forEach((product) => {
        if(checkItems.value[product.id]) {
          counterChecked++
        }
        if(value && listItemSelected.value.indexOf(product.id) === -1 && parseInt(name) === parseInt(product.id)) {
          listItemSelected.value.push(product.id)
        }else if (!value && listItemSelected.value[product.id]) {
          listItemSelected.value.splice(listItemSelected.value.indexOf(product.id), 1);
        }
      })
      checkAll.value = false
      if(counterChecked === listOrders.value.length) {
        checkAll.value = true
      }
    }

    function onChangeSelectAll(value) {
      checkAll.value = value
      for (const key in checkItems.value) {
        checkItems.value[key] = value
      }
      if(!value) {
        listItemSelected.value = []
      }else {
        listOrders.value.forEach((sync) => {
          if(listItemSelected.value.indexOf(sync.id) === -1) {
            listItemSelected.value.push(sync.id)
          }
        })
      }
    }
    function actionSelect(key) {
      if(listItemSelected.value.length === 0) {
        CommonService.showAlertPopup({
          title: 'Vui lòng chọn dữ liệu để thực hiện!',
          icon: "warning",
          showConfirmButton: false,
          timer: 1500,
          width: '800px'
        });
        return
      }
      if(listItemSelected.value.length > 1) {
        CommonService.showAlertPopup({
          title: 'Vui lòng chỉ chọn 1 dữ liệu để thực hiện!',
          icon: "warning",
          showConfirmButton: false,
          timer: 1500,
          width: '800px'
        });
      }
      switch (parseInt(key)) {
        case AppConstant.ACTION_PRINT_LABELS_ORDER_GHTK:
          printLabel();
          break;
        case AppConstant.ACTION_CANCEL_ORDER_GHTK:
          cancelOrderGHTK();
          break;
      }
    }

    async function printLabel() {
      const params = {
        company_id: accountStore.account.company.id,
        order_id: listItemSelected.value[0],
        store_id: storeCompStore.usingStore.id,
        original: 'portrait',
        page_size: 'A5',
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/third-party/ghtk/print-label';
      const res = await syncGHTKStore.printLabel(url, params);

      const fileURL = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      window.open(fileURL);

      const link = document.createElement('a');
      link.href = fileURL;
      link.setAttribute('download', `label.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    }

    async function cancelOrderGHTK() {
      CommonService.showAlertConfirmPopup({
        title: 'Bạn chắc chắn muốn huỷ bỏ đơn giao hàng này?',
        width: '800px'
      }).then(async (result) => {
        if (result.isConfirmed) {
          const params = {
            company_id: accountStore.account.company.id,
            order_id: listItemSelected.value[0],
            store_id: storeCompStore.usingStore.id,
          }
          const url = AppConstant.URL_API_LOCAL + 'api/v1/third-party/ghtk/cancel-order';
          const res = await syncGHTKStore.cancelOrderGHTK(url, params);
          const errorMessageRes = await ErrorMessageService.getErrorMessage(res)
          if(errorMessageRes !== undefined && errorMessageRes.length > 0) {
            errorMessage.value = typeof errorMessageRes === 'string' ? [errorMessageRes] : errorMessageRes;
          } else {
            await CommonService.showAlertPopup({
              title: res?.message,
              icon: res?.status,
              showConfirmButton: false,
              timer: 1200,
              width: '800px'
            });
          }
        }
      });

    }

    async function actionLimitPage(key) {
      switch (parseInt(key)) {
        case AppConstant.LIMIT_PAGE_10:
          await getListOrder(1, AppConstant.LIMIT_PAGE_10);
          break;
        case AppConstant.LIMIT_PAGE_20:
          await getListOrder(1, AppConstant.LIMIT_PAGE_20);
          break;
        case AppConstant.LIMIT_PAGE_50:
          await getListOrder(1, AppConstant.LIMIT_PAGE_50);
          break;
      }
    }

    function redirectToCreate() {
      router.push('/third-party/ghtk/order/create')
    }

    async function deleteGHTK(syncId) {
      const params = {
        company_id: accountStore.account.company.id,
        store_id: dataSearch.value.store_id.value,
        sync_id: syncId
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/third-party/ghtk/list-sync-ghtk';
      const res =  await syncGHTKStore.deleteGHTK(url, params);
      const errorMessageRes = await ErrorMessageService.getErrorMessage(res)
      if(errorMessageRes !== undefined && errorMessageRes.length > 0) {
        errorMessage.value = typeof errorMessageRes === 'string' ? [errorMessageRes] : errorMessageRes;
      } else {
        await CommonService.showAlertPopup({
          title: res?.message,
          icon: "success",
          showConfirmButton: false,
          timer: 1000,
          width: '800px'
        });
      }
    }

    function actionDateSelected(date) {
      stateModal.modalCalendar.hide()
      ghtkExpirationDateSelected.value = CommonService.formatDate(date)
      AppConstant.GHTK_EXPIRATION_DATE_TOKEN.push({
        value: 9,
        name: ghtkExpirationDateSelected.value,
        style: {
          hidden: true
        }
      })
      dataSearch.value.expired_at.value = 9
    }

    function filterByStatus(statusId) {
      dataSearch.value.status.value = statusId
      getListOrder(1);
    }


    function showErrorMessage(mess) {
      messError.value = mess
    }

    function removeError() {
      messError.value = ''
    }

    return {
      dataHeaderTable,
      labelButtonSearch,
      labelButtonCreate,
      dataSearch,
      listGHTK,
      listOrders,
      paginate,
      urlOrigin,
      checkAll,
      listItemSelected,
      checkItems,
      selectAction,
      selectLimitPage,
      eventClickShowModalExport,
      eventClickShowModalImport,
      listProductsSelected,
      isLoading,
      messError,
      location,
      table,
      errorMessage,
      statusOrder,
      filterByStatus,
      redirectToCreate,
      onChange,
      searchGHTK,
      actionSelect,
      actionLimitPage,
      showErrorMessage,
      removeError,
      showSyncGHTKDetail,
      onChangeSelectItem,
      onChangeSelectAll,
      actionDateSelected,
      CommonService,
      CommonText
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 265px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        .btn-invite-partner {
          width: 150px;
          margin-top: 50px;
        }
        .list-partners-component {
          margin-top: 30px;
          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;
            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
          td.product-name {
            max-width: 500px;
            p {
              overflow-y: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
              margin: 0;
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }
        .status-container {
          display: grid;
          grid-template-columns: repeat(6, 1fr);
          width: 100%;
          gap: 50px;
          margin: 20px auto;
          padding: 0;
          box-sizing: border-box;
          .status-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 22px 10px;
            border-radius: 14px;
            background: linear-gradient(180deg, #f9fafb 0%, #eef2ff 100%);
            color: #1e3a8a;
            text-align: center;
            font-weight: 600;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.25s ease;
            border: 1px solid #e2e8f0;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.04);
            &:hover {
              background: linear-gradient(180deg, #e0f2fe 0%, #bfdbfe 100%);
              color: #1d4ed8;
              border-color: #93c5fd;
              transform: translateY(-3px);
              box-shadow: 0 6px 14px rgba(59, 130, 246, 0.15);
            }
            &.active {
              background: linear-gradient(135deg, #2563eb, #3b82f6);
              color: #fff;
              border: none;
              transform: scale(1.04);
              box-shadow: 0 8px 20px rgba(37, 99, 235, 0.35);
            }
            .status-icon {
              font-size: 22px;
              margin-bottom: 6px;
              opacity: 0.9;
            }
          }
        }
      }
    }
  }
}
</style>
